import { GameUI } from "game/gameUI/GameUI";
import { translate } from "game/translate"
import { Popups } from "ui/types/popups";

export const TutorialSkipPopup = () => {
    const handleCloseBtnClick = () => {
        GameUI.closePopup(Popups.TUTORIAL_SKIP);
        document.dispatchEvent(new CustomEvent('closeModal', { detail: { id: 'tutorial_skip', confirm: false, button: document.querySelector('.close_btn') } }));
    }

    const handleSkipBtnClick = () => {
        GameUI.closePopup(Popups.TUTORIAL_SKIP, true);
        document.dispatchEvent(new CustomEvent('closeModal', { detail: { id: 'tutorial_skip', confirm: true } }));
    }
    
    return (
        <div id="tutorial_skip" role="tooltip" className="modals_area active">
            <div className="wrapper">
                <button type="button" className="close_btn close" onClick={handleCloseBtnClick}></button>
                <div className="text_content">
                    <span className="modals_area-title">{translate("tutorial_skip_title")}</span>
                    <p className="modals_area-text">{translate("tutorial_skip_text")}</p>
                    <button type="button" className="modals_area-btn" onClick={handleSkipBtnClick}>{translate("tutorial_skip_button")}</button>
                </div>
            </div>
        </div>
    )
}




